<template>
  <div style="height: 735px;width: 100%;">
<!--   <TT /> -->
<!--   <br />
  <T1 /> -->
  </div>
</template>
<script>
import tt from '../../components/smart_cloud/docfolder.vue'
// import t1 from '../../components/smart_cloud/droptree_child.vue'

// const utterance = new SpeechSynthesisUtterance()
// utterance.text = `海关总署
// 关于修改部分规章的决定（2023年）为贯彻落实党的二十大精神，按照党中央、国务院关于优化营商环境的决策部署以及全面实行行政许可事项清单管理的有关要求，海关总署决定对《中华人民共和国海关预裁定管理暂行办法》等22部规章进行修改，具体内容如下：
// 一、对《中华人民共和国海关预裁定管理暂行办法》（海关总署令第 236 号公布）作如下修改：
// （一）将第四条中的“注册登记”修改为“备案”。
// （二）将第七条第一款中的“注册”修改为“备案”。
// 二、对《中华人民共和国海关加工贸易货物监管办法》（海关总署令第 219 号公布，根据海关总署令第 235 号、第 240 号、第 243 号、第 247 号修正）作如下修改：
// （一）将第十二条第一款中的“按照本办法第十一条、第十二条规定”修改为“按照本办法第十条、第十一条规定”。
// （二）将第四十条中的“加工贸易企业，包括经海关注册登记的经营企业和加工企业”修改为“加工贸易企业，包括经海关备案的`
// utterance.rate = 3



export default {
  name: 'Test',
  components:{
    "TT":tt,
    // "T1":t1,
  },
  data() {
    return {
    }
  },
  methods:{
    // txt2speach(){
    //   speechSynthesis.speak(utterance)
    // }
  },
}

</script>
<style lang="less" scoped>
// .test > sr{
//     color:red;
//     font-size:16px;
// }
</style>